var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81998 1H8.81998C8.81998 1 8.81998 4 11.82 4C14.82 4 14.82 1 14.82 1H17.82M17.82 8V16.4C17.82 16.5591 17.7568 16.7117 17.6442 16.8243C17.5317 16.9368 17.3791 17 17.22 17H6.41998C6.26085 17 6.10823 16.9368 5.99571 16.8243C5.88319 16.7117 5.81998 16.5591 5.81998 16.4V8M17.82 1L22.263 2.777C22.4107 2.83615 22.5289 2.95155 22.5915 3.09783C22.6541 3.24411 22.6561 3.40927 22.597 3.557L20.971 7.623C20.9264 7.73429 20.8495 7.82969 20.7503 7.89688C20.651 7.96408 20.5339 8 20.414 8H17.82M5.81998 1L1.37698 2.777C1.22925 2.83615 1.11108 2.95155 1.04844 3.09783C0.985803 3.24411 0.983838 3.40927 1.04298 3.557L2.66898 7.623C2.71353 7.73429 2.79041 7.82969 2.88968 7.89688C2.98896 7.96408 3.10609 8 3.22598 8H5.81998",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerch);
export default __webpack_public_path__ + "static/media/merch.64cab3deee1863a530c9242c3d4e62f7.svg";
export { ForwardRef as ReactComponent };